import React from 'react';
import './AlertPageFrame.css';

export default function AlertPageFrame({ onClose, label, children }) {
  return <div className={onClose ? 'alert-page-frame' : undefined}>
    {onClose && <button type="button" className="panel-close-btn alert-page-close" onClick={onClose} aria-label={`Close ${label}`} title={`Close ${label}`} />}
    {children}
  </div>;
}
